import React, { useContext } from "react";
import "./Our_Academic_Network.css";
import { Context } from "../../../utils/context";

function Our_Academic_Network() {
  const { language } = useContext(Context);

  return (
    <>
      <section className="Our_Academic_Network">
        <div className="container">
          <div className="row">
            <div className="col-md-8">
              <div className="text_holder">
                <h4>
                  {language == 1
                    ? "Our Global Academic Network"
                    : "Notre réseau académique mondial"}
                </h4>

                <p>
                  {language == 1
                    ? "Through years of collaboration, AFI has built a trusted academic network across key destinations: France, the USA, Georgia, and Korea."
                    : "Grâce à des années de collaboration, AFI a construit un réseau académique de confiance dans des destinations clés : la France, les États-Unis, la Géorgie et la Corée."}
                </p>

                <h2>
                  {language == 1
                    ? "THESE INSTITUTIONS SHARE ONE MISSION"
                    : "CES INSTITUTIONS PARTAGENT UNE MISSION"}
                </h2>

                <p>
                  {language == 1
                    ? "Developing international students through real world learning."
                    : "Former des étudiants internationaux grâce à un apprentissage concret et ancré dans le monde réel."}
                </p>
              </div>
            </div>

            <div className="col-md-4">
              <div className="img_holder">
                <img
                  src="/assets/images/study_abroad/our_Academic_Network/Our-Global.jpg"
                  alt=" academic network"
                  className="Our_Academic_Network_img"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Our_Academic_Network;
